export type DeleteProjectStakeholdersResponse = {};
